module.exports = __webpack_public_path__ + "ui-icons_ffffff_256x240.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-icons_ffffff_256x240.png
// module id = 810
// module chunks = 1